
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<ExpansionPanel>({})
export default class ExpansionPanel extends Vue {
	@Prop({ type: String, required: true }) private title!: string;
	@Prop({ type: String, required: false, default: '' }) private subtitle!: string;
	@Prop({ type: Boolean, required: false, default: false }) private open!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private nested!: boolean;
	@Prop({ type: Number, required: false, default: 1 }) private animationSpeed!: number; // pixels per ms

	$refs!: {
		content: HTMLElement;
		contentWrapper: HTMLElement;
	};

	private isOpen: boolean = this.open;
	private animationDuration: number = 300;

	/**
	 * Computed style for the animation duration based on content height
	 *
	 * @return {{ transition: string }}
	 */
	private get animationStyle(): { transition: string } {
		return {
			transition: `grid-template-rows ${this.animationDuration}ms ease`
		};
	}

	/**
	 * Computed style for the header border transition delay
	 * Duration is slightly shorter than the collapse animation to avoid abrupt changes
	 *
	 * @return {Record<string, string>}
	 */
	private get headerStyle(): Record<string, string> {
		return this.isOpen ? {} : {
			transitionDelay: `0s, ${this.animationDuration - 50}ms`
		};
	}

	private mounted(): void {
		this.updateAnimationDuration();
	}

	private updated(): void {
		this.updateAnimationDuration();
	}

	/**
	 * Calculate animation duration based on content height
	 *
	 * @return {void}
	 */
	private updateAnimationDuration(): void {
		if (this.$refs.content) {
			const height = this.$refs.content.scrollHeight;
			// Calculate duration: height in pixels / speed (pixels per ms)
			// Clamp between 200ms and 1000ms to prevent too fast or too slow animation duration
			this.animationDuration = Math.max(200, Math.min(1000, height / this.animationSpeed));
		}
	}

	private togglePanel(): void {
		this.isOpen = !this.isOpen;
		this.$emit('toggle', this.isOpen);
	}
}
